import React, { Component } from "react";
import {  Form, Container, Row, Col, Button } from "react-bootstrap";
import PropertyList from "containers/property/PropertyList";
import 'containers/common/Detail.css';
import { PacmanLoader } from 'react-spinners';
import { API } from "aws-amplify";
import axios from 'axios';

import 'react-table/react-table.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

import Moment from "moment";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class PropertySearch extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false; //this is to deal with the component unmounting but state trying to be updated. At the time Amplify is not supporting the axios cancel
        this.updateTableState = this.updateTableState.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);
        this.saveBrowseList = this.saveBrowseList.bind(this);
        this.handleBrowseListChange = this.handleBrowseListChange.bind(this);
        this.handleBrowseListInputChange = this.handleBrowseListInputChange.bind(this);
        this.searchBrowseList = this.searchBrowseList.bind(this);
        this.deleteBrowseList = this.deleteBrowseList.bind(this);
                                
        this.state = {
            searching: false,
            historicalSearchOptions: [],
            selectedHistoricalSearchOption: {},
            browseListsOptions :[],
            cityscopeOptions: [] ,
            stateOptions: [] ,
            selectedBrowseListOption: null,
            selectedCityscopeOption: null,
            selectedStateOption: null,
            propertyKey: null,
            buildingName: null,
            address: null,
            address2: null,
            stnolow: null,
            stnohigh: null,
            description: null,
            zoning: null,
            historical: null,
            title: null,
            saleshistory: null,
            valuations: null,
            tenant: null,
            propsal: null,
            saleappendix: null,
            photorequired: null,
            activequeryfollowup: null,
            perpetual: null,
            saledateentered: null,
            salesheetfollowup: null,
            ownername: null,
            browselistid: null,
            browselistidfilter: null,
            scope: null,
            state: null,
            hasleasingagent: null,
            missingphoto: null,
            isLoading: false,
            properties: [],
            filter: {user: this.props.user,
                      screen: "property"}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated ) { // if false
            return;
        }
        try {
            console.log(this.state.filter);
            //const properties = await this.getProperties(this.state.filter);
            //this.setState({ properties });

            
            this.getHistoricalSearchDropDown(this.state.filter);
            this.getUserBrowseListsDropDown(this.state.filter);
            this.getCityscopes();
            this.getStates();

        } catch (e) {
            alert(e);
        }

        document.title = "Cityscope Property Search";
        this.setState({ isLoading: false });      
    }
    componentWillUnmount() {
        source.cancel();
    }

    //API
    async getProperties(filter) {
        console.log("Inside getProperties()");

        console.log(filter);

        //  this.setState({ searching : true });

        const response = API.get("colin", "/properties", { 'queryStringParameters': filter})           
        try {
            return await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }

    getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions ) {
                    console.log("Found cityscopes");
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }

    getStates() {
        try {
            API.get("colin", `/states`, { 'cancelToken': source.token }).then((stateOptions) => {
                if (stateOptions ) {
                    this.setState(state => ({ stateOptions }));
                }
            });
        }
        catch{
            console.log("Error getting states");
        }
    }

    getHistoricalSearchDropDown(filter) {
        try {
            API.get("colin", "/searches", { 'queryStringParameters': filter, 'cancelToken': source.token }).then((historicalSearchOptions) => {
                if (historicalSearchOptions) {
                    this.setState(state => ({ historicalSearchOptions }));
                    if (historicalSearchOptions.length > 0) {
                        let selectedHistoricalSearchOption = historicalSearchOptions[0]
                        this.setState({ selectedHistoricalSearchOption });
                    }
                }
            }
            );
        }
        catch{
            console.log("Error getting historical searches");
        }
    }

    getUserBrowseListsDropDown(filter) {
        try {
            API.get("colin", "/browselists", { 'queryStringParameters': filter, 'cancelToken': source.token }).then((browseListsOptions) => {
                if (browseListsOptions) {
                    this.setState(state => ({ browseListsOptions }));
                    
                }
            }
            );
        }
        catch{
            console.log("Error getting browse lists");
        }
    }

    handleSearchChange = (selectedHistoricalSearchOption) => {
        
        this.setState({ selectedHistoricalSearchOption });

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('propertykey')) {
            this.setState({ propertyKey: JSON.parse(selectedHistoricalSearchOption.search_parameters).propertykey });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('address')) {
            this.setState({ address: JSON.parse(selectedHistoricalSearchOption.search_parameters).address });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('address2')) {
            this.setState({ address2: JSON.parse(selectedHistoricalSearchOption.search_parameters).address2 });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('buildingname')) {
            this.setState({ buildingName: JSON.parse(selectedHistoricalSearchOption.search_parameters).buildingname });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('stnolow')) {
            this.setState({ stnolow: JSON.parse(selectedHistoricalSearchOption.search_parameters).stnolow });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('stnohigh')) {
            this.setState({ stnohigh: JSON.parse(selectedHistoricalSearchOption.search_parameters).stnohigh });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('description')) {
            this.setState({ description: JSON.parse(selectedHistoricalSearchOption.search_parameters).description });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('zoning')) {
            this.setState({ zoning: JSON.parse(selectedHistoricalSearchOption.search_parameters).zoning });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('historical')) {
            this.setState({ historical: JSON.parse(selectedHistoricalSearchOption.search_parameters).historical });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('title')) {
            this.setState({ title: JSON.parse(selectedHistoricalSearchOption.search_parameters).title });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('saleshistory')) {
            this.setState({ saleshistory: JSON.parse(selectedHistoricalSearchOption.search_parameters).saleshistory });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('valuations')) {
            this.setState({ valuations: JSON.parse(selectedHistoricalSearchOption.search_parameters).valuations });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('tenant')) {
            this.setState({ tenant: JSON.parse(selectedHistoricalSearchOption.search_parameters).tenant });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('proposal')) {
            this.setState({ proposal: JSON.parse(selectedHistoricalSearchOption.search_parameters).proposal });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('saleappendix')) {
            this.setState({ saleappendix: JSON.parse(selectedHistoricalSearchOption.search_parameters).saleappendix });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('photorequired')) {
            this.setState({ photorequired: JSON.parse(selectedHistoricalSearchOption.search_parameters).photorequired });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('activequeryfollowup')) {
            this.setState({ activequeryfollowup: JSON.parse(selectedHistoricalSearchOption.search_parameters).activequery });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('perpetual')) {
            this.setState({ perpetual: JSON.parse(selectedHistoricalSearchOption.search_parameters).perpetual });
        }
        
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('saledateentered')) {
            this.setState({ saledateentered: JSON.parse(selectedHistoricalSearchOption.search_parameters).saledateentered });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('salesheetfollowup')) {
            this.setState({ salesheetfollowup: JSON.parse(selectedHistoricalSearchOption.search_parameters).salesheetfollowup });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('ownername')) {
            this.setState({ ownername: JSON.parse(selectedHistoricalSearchOption.search_parameters).ownername });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('browselistid')) {
            this.setState({ browselistidfilter: JSON.parse(selectedHistoricalSearchOption.search_parameters).browselistid });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('state')) {
            this.setState({ state: JSON.parse(selectedHistoricalSearchOption.search_parameters).state });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('scope')) {
            this.setState({ scope: JSON.parse(selectedHistoricalSearchOption.search_parameters).scope });
        }

        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('hasleasingagent')) {
            this.setState({ hasleasingagent: JSON.parse(selectedHistoricalSearchOption.search_parameters).hasleasingagent });
        }
        if (JSON.parse(selectedHistoricalSearchOption.search_parameters).hasOwnProperty('missingphoto')) {
            this.setState({ missingphoto: JSON.parse(selectedHistoricalSearchOption.search_parameters).missingphoto });
        }
        
        
        document.getElementById("submit").click();

    }

    handleChange = event => {
        
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }


    handleDateChange(date, name) {
        if (date) {
            this.setState({
                [name]: new Date(date)
            });
        }
        else {
            this.setState({
                [name]: null
            });
        }
        this.setState({ modified: true });
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })

        

    }

    handleCityscopeChange = (selectedCityscopeOption) => {
        this.setState({ modified: true });
        if (selectedCityscopeOption) {
            this.setState({ selectedCityscopeOption, scope: selectedCityscopeOption.value });          
        }
        else {
            this.setState({ selectedCityscopeOption: { value: null, label: null } });
            this.setState({ scope: null });
            
        }
    }

    handleStateChange = (selectedStateOption) => {
        this.setState({ modified: true });
        if (selectedStateOption) {
            this.setState({ selectedStateOption, state: selectedStateOption.value });          
        }
        else {
            this.setState({ selectedStateOption: { value: null, label: null } });
            this.setState({ state: null });
            
        }
    }



    handleBrowseListChange = (selectedBrowseListOption) => {
        this.setState({ modified: true });
        if (selectedBrowseListOption) {
            this.setState({ selectedBrowseListOption, browselistid: selectedBrowseListOption.value });
          
        }
        else {
            this.setState({ selectedBrowseListOption: { value: null, label: null } });
            this.setState({ browselistid: null });
            
        }
    }

    handleBrowseListInputChange = event => {
        this.setState({ suburb: event });
        
        let browseListsOptions = [...this.state.browseListsOptions];
        browseListsOptions.push({
            value: event, label: event
        });
        this.setState(state => ({ browseListsOptions }));        
        this.setState(state => ({ selectedBrowseListOption: { value: "new", label: event }, browselistid: "new" }));
      
    }

    async searchBrowseList(){
        console.log("searchBrowseList " );
        let result = await this.clearFilters();
        this.setState({browselistidfilter: this.state.browselistid}, this.handleSubmit);
        
    }

    deleteBrowseList = async event =>{
        if(this.state.selectedBrowseListOption!== null){
            let confirmed = window.confirm("Are you sure you want to delete the selected browse list?");
            if (confirmed) {
                const result = await  API.put("colin", `/browselists/${this.state.browselistid}`, {
                    body: {properties: {}, user: this.props.user}
                });
                if (result.result === false) {
                    alert(result.error_message);
                }
                else{
                    let browseListsOptions = [...this.state.browseListsOptions];
                    let index = browseListsOptions.map(f => f.value).indexOf(this.state.browselistid);
                    browseListsOptions.splice(index, 1);
                    this.setState(state => ({ browseListsOptions }));        
                    this.setState(state => ({ selectedBrowseListOption: { value: null, label: null }, browselistid: null }));
                }
            }
            
           
            
        }
    }
    saveBrowseList = async event =>{
        if(this.state.selectedBrowseListOption!== null){
            console.log("In saveBrowseList")
            const properties = this.state.properties.filter(prop => prop.selected).map(prop => prop.property_id);
            let result=null;
            if (this.state.browselistid === "new") {
                const browselist = {
                    user_name: this.props.user,
                    browse_list_name: this.state.selectedBrowseListOption.label
                }
                result = await API.post("colin", `/browselists/new`, { body: {browselist: browselist, properties: properties} });
                this.setState(state => ({ browselistid: result.id, selectedBrowseListOption: { value: result.id, label: this.state.selectedBrowseListOption.label } }));
            }
            else{
                result = await  API.put("colin", `/browselists/${this.state.browselistid}`, {
                                        body: {properties: properties, user: this.props.user}
                                    });
                
            }
            if (result.result === false) {
                alert(result.error_message);
            }
            else{
                alert("Browse list updated")
                
            }
            
        }
        else{
            alert("Select a browse list on the left, or type a new browse list name to create a new browse list.");
        }
    }

    

    

    async clearFilters() {
        console.log("clearFilters");
        this.setState({
              propertyKey: ""
            , buildingName: ""
            , address: ""
            , address2: ""
            , stnolow: ""
            , stnohigh: ""
            , description: ""
            , zoning: ""
            , historical: ""
            , title: ""
            , saleshistory: ""
            , valuations: ""
            , tenant: ""
            , proposal: ""
            , saleappendix: ""
            , photorequired: null
            , activequeryfollowup: null
            , perpetual: null
            , saledateentered: null
            , salesheetfollowup: null
            , ownername: null            
            , browselistidfilter: null
            , state: null
            , scope: null
            // , selectedBrowseListOption: {value: null, label: null}
            , selectedCityscopeOption: {value: null, label: null}
            , selectedStateOption: {value: null, label: null}
            , hasleasingagent: null
            , missingphoto: null
            , filter: {
                user: this.props.user,
                screen: "property"
            }
        });
    }

    async handleSubmit(event) {
        if(event){
            event.preventDefault();
        }
        this.setState({ isLoading: true });         
        
        const properties = await this.getProperties({
            propertykey: this.state.propertyKey,
            buildingname: this.state.buildingName,
            address: this.state.address,
            address2: this.state.address2,
            stnolow: this.state.stnolow,
            stnohigh: this.state.stnohigh,
            description: this.state.description,
            zoning: this.state.zoning,
            historical: this.state.historical,
            title: this.state.title,
            saleshistory: this.state.saleshistory,
            valuations: this.state.valuations,
            tenant: this.state.tenant,
            proposal: this.state.proposal,
            saleappendix: this.state.saleappendix,
            photorequired: this.state.photorequired,
            activequeryfollowup: this.state.activequeryfollowup !== null ? Moment(this.state.activequeryfollowup).local().format():"",
            perpetual: this.state.perpetual,
            saledateentered:this.state.saledateentered !== null ? Moment(this.state.saledateentered).local().format():"",
            salesheetfollowup: this.state.salesheetfollowup !== null? Moment(this.state.salesheetfollowup).local().format():"",
            ownername: this.state.ownername,
            browselistid: this.state.browselistidfilter,
            state: this.state.state,
            scope: this.state.scope,
            hasleasingagent: this.state.hasleasingagent,
            missingphoto: this.state.missingphoto,
            user: this.props.user,
            screen: "property"
        } );
        this.setState({ properties: properties, browselistidfilter: null,isLoading: false });
           


     }

     validateRelatedRecord(record, set) {
         return [true,];
     }
     updateTableState(data, set) {
        
        this.setState({
            [set]: data
        });
    }

   
    renderProperties() {
        return (
            
                <Container fluid >       
                    <Row >
                        <Col sm={12} md={12} lg={12}>
                            <h6>
                                Cityscope Property Search
                                </h6>
                    
                        </Col>
                    </Row>
               <Row>        
             <Col md={3} lg={3}>
                    <Form onSubmit={this.handleSubmit}>
                

                            
                            
                            <Row>
                            <Col >
                                <Button type="submit" id="submit" >Search</Button>
                            </Col>
                            <Col >
                                <Button  onClick={this.clearFilters}>Clear Filters</Button>
                            </Col>
                        </Row>
                        <hr/>
                       
                        <br/>
                        <Form.Row>

                            <Col >
                                <Form.Group controlId="propertyKey">
                                    <Form.Control
                                        value={this.state.propertyKey}
                                        onChange={this.handleChange}
                                        as="input"
                                        type="text"
                                        placeholder="Cityscope Reference starting"
                                    />
                                </Form.Group>
                                </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col lg={3}>
                                
                                <Form.Group controlId="stnolow">
                                    <Form.Control
                                        type="input"
                                        value={this.state.stnolow}
                                        onChange={this.handleChange}
                                        placeholder="St No. Low" />
                                </Form.Group>
                            </Col>
                           
                            <Col lg={3}>
                                <Form.Group controlId="stnohigh">
                                    <Form.Control
                                        type="input"
                                        value={this.state.stnohigh}
                                        onChange={this.handleChange}
                                        placeholder="St No. High" />
                                        </Form.Group>
                                    
                            </Col>
                          
                            <Col >
                            <Form.Group controlId="address">
                                    <Form.Control
                                        type="input"
                                        value={this.state.address}
                                        onChange={this.handleChange}
                                        placeholder="Street Name starting" />
                                
                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col >
                            <Form.Group   controlId="state" >

                                <Select
                                    value={this.state.selectedStateOption}
                                    onChange={this.handleStateChange}
                                    options={this.state.stateOptions}
                                    onInputChange={this.handleInputChange}     
                                    placeholder="State"  
                                    isClearable={true}                            
                                />
                            </Form.Group>
                            </Col>
                            <Col >
                            <Form.Group  controlId="scope" >
                               
                                <Select
                                    value={this.state.selectedCityscopeOption}
                                    onChange={this.handleCityscopeChange}
                                    options={this.state.cityscopeOptions}
                                    onInputChange={this.handleInputChange}   
                                    placeholder="Scope"       
                                    isClearable={true}                      
                                />
                            </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                                 <Col >
                                <Form.Group controlId="address2">
                                        <Form.Control
                                            type="input"
                                            value={this.state.address2}
                                            onChange={this.handleChange}
                                            placeholder="Street Name 2 starting - use for cnr properties" />
                                            
                                    </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col>
                            <Form.Group controlId="buildingName">
                                
                                    <Form.Control
                                        type="input"
                                        value={this.state.buildingName}
                                        onChange={this.handleChange}
                                        placeholder="Building Name containing"
                                    />
                                
                            </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col>
                            <Form.Group controlId="ownername">
                                
                                    <Form.Control
                                        type="input"
                                        value={this.state.ownername}
                                        onChange={this.handleChange}
                                        placeholder="Owner Name containing"
                                    />
                                
                            </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="saleappendix">

                                    <Form.Control
                                        type="input"
                                        value={this.state.saleappendix}
                                        onChange={this.handleChange}
                                        placeholder="Sales Appendix equals"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="tenant">

                                    <Form.Control
                                        type="input"
                                        value={this.state.tenant}
                                        onChange={this.handleChange}
                                        placeholder="Tenant Text (including pre/postamble) containing"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="description">

                                    <Form.Control
                                        type="input"
                                        value={this.state.description}
                                        onChange={this.handleChange}
                                        placeholder="Description containing"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            
                            <Col >
                                <Form.Group controlId="zoning">

                                    <Form.Control
                                        type="input"
                                        value={this.state.zoning}
                                        onChange={this.handleChange}
                                        placeholder="Zoning containing"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="historical">

                                    <Form.Control
                                        type="input"
                                        value={this.state.historical}
                                        onChange={this.handleChange}
                                        placeholder="Historic Listings containing"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>

                            <Col >
                                <Form.Group controlId="title">

                                    <Form.Control
                                        type="input"
                                        value={this.state.title}
                                        onChange={this.handleChange}
                                        placeholder="Title Details containing"
                                    />

                                </Form.Group>
                            </Col>

                            </Form.Row>
                            <Form.Row>
                    
                            <Col >
                                <Form.Group controlId="saleshistory">

                                    <Form.Control
                                        type="input"
                                        value={this.state.saleshistory}
                                        onChange={this.handleChange}
                                        placeholder="Sales History containing"
                                    />

                                </Form.Group>
                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="valuations">

                                    <Form.Control
                                        type="input"
                                        value={this.state.valuations}
                                        onChange={this.handleChange}
                                        placeholder="For Lease Text (including pre/postamble) containing"
                                    />

                                </Form.Group>
                            </Col>

                            </Form.Row>
                            <Form.Row>

                            

                            <Col >
                                <Form.Group controlId="proposal">

                                    <Form.Control
                                        type="input"
                                        value={this.state.proposal}
                                        onChange={this.handleChange}
                                        placeholder="Proposals Text containing"
                                    />

                                </Form.Group>
                            </Col>

                            </Form.Row>
                            <Form.Row>
                            <Col  lg={6}>
                            
                                <Form.Group controlId="activequeryfollowup" >

                                    
                                        <DatePicker
                                            selected={this.state.activequeryfollowup}
                                            onChange={e => this.handleDateChange(e, "activequeryfollowup")}
                                            dateFormat="dd/MM/yyyy"
                                            onBlur={this.handleBlur}
                                            className="form-control"
                                            placeholderText="Query Resolve Date Before"
                                            isClearable
                                        />
                                    


                                </Form.Group>
                                
                            </Col>
                            
                            <Col lg={6}>
                                <Form.Group controlId="perpetual">

                                    <Form.Check checked={this.state.perpetual}
                                        onChange={this.handleCheckBoxChange}
                                        label="Exclude Perpetual"
                                        type="checkbox"
                                        name="perpetual"
                                        onBlur={this.handleBlur}
                                        
                                    />

                                </Form.Group>





                            </Col>
                            </Form.Row>
                            <Form.Row>
                            <Col  lg={6}>
                                <Form.Group controlId="salesheetfollowup" >

                                    <div className="customDatePickerWidth">
                                        <DatePicker
                                            selected={this.state.salesheetfollowup}
                                            onChange={e => this.handleDateChange(e, "salesheetfollowup")}
                                            dateFormat="dd/MM/yyyy"
                                            onBlur={this.handleBlur}
                                            className="form-control"
                                            placeholderText="Sale Sheet Followup Date Before"
                                            isClearable
                                        />
                                    </div>


                                </Form.Group>
                            </Col>
                          
                            <Col >
                                <Form.Group controlId="saledateentered" >

                                    <div className="customDatePickerWidth">
                                        <DatePicker
                                            selected={this.state.saledateentered}
                                            onChange={e => this.handleDateChange(e, "saledateentered")}
                                            dateFormat="dd/MM/yyyy"
                                            onBlur={this.handleBlur}
                                            className="form-control"
                                            placeholderText="Sale Entered Date Since"
                                            isClearable
                                        />
                                    </div>


                                </Form.Group>
                            </Col>
                            </Form.Row>
                           
                            <Form.Row>
                            <Col >
                                <Form.Group controlId="photorequired">

                                    <Form.Check checked={this.state.photorequired}
                                        onChange={this.handleCheckBoxChange}
                                        label="Photo Required"
                                        type="checkbox"
                                        name="photorequired"
                                        onBlur={this.handleBlur}

                                    />

                                </Form.Group>
                            </Col>


                        </Form.Row>
                        <Form.Row>
                        <Col lg={6}>
                                <Form.Group controlId="hasleasingagent">

                                    <Form.Check checked={this.state.hasleasingagent}
                                        onChange={this.handleCheckBoxChange}
                                        label="Has Leasing Agent?"
                                        type="checkbox"
                                        name="hasleasingagent"
                                        onBlur={this.handleBlur}                                        
                                    />

                                </Form.Group>


                            </Col>
                            </Form.Row>
                            <Form.Row>
                        <Col lg={6}>
                                <Form.Group controlId="missingphoto">

                                    <Form.Check checked={this.state.missingphoto}
                                        onChange={this.handleCheckBoxChange}
                                        label="Property Missing Photo?"
                                        type="checkbox"
                                        name="missingphoto"
                                        onBlur={this.handleBlur}                                        
                                    />

                                </Form.Group>


                            </Col>
                            </Form.Row>
                            
                        <Form.Row>
                            <Form.Group as={Col} column  controlId="cityscope" >
                                <Form.Label className="text-right" >Historical Searches</Form.Label>

                                <Select
                                    value={this.state.selectedHistoricalSearchOption}
                                    onChange={this.handleSearchChange}
                                    options={this.state.historicalSearchOptions}
                                    onInputChange={this.handleInputChange}
                                
                                />


                            </Form.Group>
                        </Form.Row>
                    </Form>
                            
                </Col>
                <Col md={9} lg={9}>

                {this.state.isLoading &&
                    <div className="outer-div"><div className='sweet-loading inner-div' >
                        <PacmanLoader
                            css="display: block;
                            margin: 0 auto;
                             border-color: red"
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                        />
                </div>
                    </div>}
                    {!this.state.isLoading &&
                            <PropertyList
                                filter={this.state.filter}
                                isAuthenticated={this.props.isAuthenticated}
                                isLoading={this.state.isLoading}
                                data={this.state.properties}
                                controlType="table"
                                updateTableState={this.updateTableState}
                                validateRelatedRecord={this.validateRelatedRecord}
                                saveBrowseList={this.saveBrowseList}
                                browseListsOptions={this.state.browseListsOptions}
                                handleBrowseListChange ={this.handleBrowseListChange}
                                handleBrowseListInputChange = {this.handleBrowseListInputChange}
                                deleteBrowseList={this.deleteBrowseList}
                                selectedBrowseListOption={this.state.selectedBrowseListOption}
                                searchBrowseList={this.searchBrowseList}
                            />
                    }
                     
                </Col>
                </Row> 

                </Container>

        );
    }
  render() {
    return (

        <div className="PropertySearch">
            {this.props.isAuthenticated  && this.props.user ? this.renderProperties() : console.log("error)")}
        </div>
    );
  }
}
